import range from "lodash/range"
import store from "../../shared_component/utils/configureStore"
import has from "lodash/has"
import i18n from "../../shared_component/utils/i18n"
import { DEFAULT_IMG_URL } from "../constants/confirmDetails"

const EARLIEST_AVAILABLE_YEAR = 1970
export function addVehicleYearRange() {
  return range(new Date().getFullYear() + 1, EARLIEST_AVAILABLE_YEAR - 1, -1)
}

export const getActiveVehicle = () => {
  const state = store.getState()
  const activeVehicleId = (state.user && state.user.activeVehicleId) || -1
  const vehicles = (state.user && state.user.vehicles) || []
  return (vehicles && vehicles.find((vehicle) => vehicle.id === activeVehicleId)) || null
}

export const getVehicleName = (vehicle = {}) => {
  let vehicleName
  if (vehicle && typeof vehicle === "object") {
    if (vehicle.year) {
      vehicleName = vehicle.year
    }
    if (vehicle.make) {
      vehicleName += " " + vehicle.make
    }
    if (vehicle.model) {
      vehicleName += " " + vehicle.model
    }
  }
  return vehicleName || null
}

export const getTransformedMaintenanceScheduleResponse = (maintenanceScheduleResponse) => {
  let maintenanceSchedule = []
  if (has(maintenanceScheduleResponse, "result.maintenance.services[0]")) {
    {
      maintenanceSchedule = maintenanceScheduleResponse.result.maintenance.services.filter(
        (service) => !!service.services.length
      )
    }
  }
  return maintenanceSchedule
}

export function selectOptions(vehicles, options = {}) {
  let vehicleOptions = []
  vehicleOptions = options.includeBlank
    ? [
        {
          value: null,
          text: i18n.t("vehicleDetails:vehicleDropdownText")
        }
      ]
    : []
  vehicles.forEach((vehicle) => {
    vehicleOptions.push({
      key: vehicle.id,
      text: fetchVehicleName(vehicle),
      image: vehicle.dashboard_mobile_url ? vehicle.dashboard_mobile_url : DEFAULT_IMG_URL,
      value: vehicle,
      isDefaultImage: !vehicle.dashboard_mobile_url
    })
  })

  return vehicleOptions
}

export const fetchVehicleName = (vehicle = {}) => {
  let vehicleName
  if (vehicle && typeof vehicle === "object") {
    if (vehicle.year) {
      vehicleName = vehicle.year
    }
    if (vehicle.make) {
      vehicleName += " " + vehicle.make
    }
    if (vehicle.model) {
      vehicleName += " " + vehicle.model
    }
  }
  return vehicleName || i18n.t("vehicleDetails:unknownLabel")
}
